import {
  Required,
  Schema,
  TextField,
  RemoteDataSource
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";
import { EmailOrEmpty } from "../../common/common";
import { createContext } from "react";

export const WebUserSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    {
      name: "login",
      type: TextField(Required),
      title: t("common:username"),
      readonly: true
    },
    {
      name: "firstName",
      type: TextField(Required),
      title: t("common:firstName"),
      readonly: true
    },
    {
      name: "lastName",
      type: TextField(Required),
      title: t("common:lastName"),
      readonly: true
    },
    {
      name: "email",
      type: TextField(Required, Required, EmailOrEmpty),
      title: t("common:email"),
      readonly: true
    }
  ]
});

mainStore.webUser = RemoteDataSource.create({
  api: api,
  name: "webUser",
  schema: WebUserSchema,
  url: "/webUsers",
  commons: mainStore.commons
});

export const webUserContext = createContext(mainStore.webUser);
